/*************************************************/
/* VIDEO PLAYER                                  */
/*************************************************/

export function videoPlayer() {
    const hiddenClass = "video-player__hidden";

    const init = (playerElement) => {
        const elements = {
            playButton: playerElement.querySelector(".video-player__icon"),
            autoplayVideo: playerElement.querySelector(".video-player__autoplay"),
            clickedVideo: playerElement.querySelector(".video-player__clicked"),
            videoText: playerElement.querySelector(".video-player__text-container"),
        };

        if (!elements.playButton || !elements.clickedVideo) {
            return; // Exit if critical elements are missing
        }

        elements.playButton.addEventListener("click", () => {
            // Hide autoplayVideo if it's not a modal
            if (elements.autoplayVideo && !elements.autoplayVideo.classList.contains("video-player__modal")) {
                elements.autoplayVideo.classList.add(hiddenClass);
                elements.videoText.classList.add(hiddenClass);
            } else if (!elements.autoplayVideo && !elements.clickedVideo.classList.contains("video-player__modal")) {
                elements.videoText.classList.add(hiddenClass);
            }

            // Show the clicked video and play it
            elements.clickedVideo.classList.remove(hiddenClass);
            const videoElement = elements.clickedVideo.querySelector(".video-item__player-selector");

            if (videoElement) {
                videoElement.click();
            }
        });
    };

    const videoPlayerInstances = document.querySelectorAll(".video-player");
    videoPlayerInstances.forEach((instance) => {
        init(instance);
    });
}
